/* tslint:disable */
/* eslint-disable */
/**
 * Optimizely Feature Experimentation API
 * This page documents how to use the Optimizely FX API. With this API you can view and manage Feature Flags and all of their related entities including Variables, Variations, Rules, and Reports.  The base URL is https://api.optimizely.com/flags/v1. Append any paths listed in these docs onto that url in order to make requests to the API.
 *
 * The version of the OpenAPI document: 0.3.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BrainstormVariablesChat
 */
export interface BrainstormVariablesChat {
    /**
     * A list of interactions including user chats and responses
     * @type {Array<object>}
     * @memberof BrainstormVariablesChat
     */
    interactions: Array<object>;
}

export function BrainstormVariablesChatFromJSON(json: any): BrainstormVariablesChat {
    return BrainstormVariablesChatFromJSONTyped(json, false);
}

export function BrainstormVariablesChatFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrainstormVariablesChat {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'interactions': json['interactions'],
    };
}

export function BrainstormVariablesChatToJSON(value?: BrainstormVariablesChat | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'interactions': value.interactions,
    };
}


